import React, { useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { openCaptureModal } from "../../features/devFeedback/devFeedbackSlice";
import {
  buildCapturedContext,
  isTypingTarget,
  resolveTripleClickTarget,
} from "../../lib/feedbackCapture";
import { t } from "../../locales";
import FeedbackCaptureDialog from "./FeedbackCaptureDialog";

const FEEDBACK_WIDGET_ATTR = "data-feedback-widget";

/**
 * Dev-only overlay: listens for a native triple-click (browsers set
 * MouseEvent.detail=3 on the third rapid click) anywhere in the app and
 * opens a feedback popup pre-filled with the clicked element's page/component
 * context. Mounted only when REACT_APP_FEEDBACK_WIDGET_ENABLED=true (see App.tsx).
 */
const FeedbackCaptureLayer: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = resolveTripleClickTarget(event);
      if (!target) return;
      if (target.closest(`[${FEEDBACK_WIDGET_ATTR}]`)) return;
      if (isTypingTarget(target)) return;

      dispatch(openCaptureModal(buildCapturedContext(target, event)));
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [dispatch]);

  return (
    <>
      <div
        className="fixed bottom-3 left-3 z-40 pointer-events-none select-none rounded-full bg-gray-900/80 text-white text-[11px] px-3 py-1 shadow-lg"
        aria-hidden="true"
      >
        {t.devFeedback.hintBadge}
      </div>
      <FeedbackCaptureDialog widgetAttr={FEEDBACK_WIDGET_ATTR} />
    </>
  );
};

export default FeedbackCaptureLayer;
